var map = {
	"./": [
		27,
		9
	],
	"./assets/fonts/Gotham-Font/AvenirLTStd-Black.otf": [
		281,
		7,
		164
	],
	"./assets/fonts/Gotham-Font/AvenirLTStd-Book.otf": [
		282,
		7,
		165
	],
	"./assets/fonts/Gotham-Font/AvenirLTStd-Roman.otf": [
		283,
		7,
		166
	],
	"./assets/fonts/Perpetua/Perpetua Bold font.ttf": [
		284,
		7,
		167
	],
	"./assets/fonts/Perpetua/per_____.ttf": [
		285,
		7,
		168
	],
	"./assets/fonts/Perpetua/perb____.ttf": [
		286,
		7,
		169
	],
	"./assets/fonts/Perpetua/perpeta.ttf": [
		287,
		7,
		170
	],
	"./assets/fonts/Perpetua/unicode.perpetua.ttf": [
		288,
		7,
		171
	],
	"./assets/fonts/ProximaNova/ProximaNova-Regular.otf": [
		289,
		7,
		172
	],
	"./assets/fonts/ProximaNova/Proxima_Nova_Alt_Bold.otf": [
		290,
		7,
		173
	],
	"./assets/fonts/ProximaNova/Proxima_Nova_Alt_Light.otf": [
		291,
		7,
		174
	],
	"./assets/fonts/ProximaNova/Proxima_Nova_Alt_Thin.otf": [
		292,
		7,
		175
	],
	"./assets/fonts/ProximaNova/Proxima_Nova_Black.otf": [
		293,
		7,
		176
	],
	"./assets/fonts/ProximaNova/Proxima_Nova_Bold.otf": [
		294,
		7,
		177
	],
	"./assets/fonts/ProximaNova/Proxima_Nova_Extrabold.otf": [
		295,
		7,
		178
	],
	"./assets/fonts/ProximaNova/Proxima_Nova_Semibold.otf": [
		296,
		7,
		179
	],
	"./assets/fonts/ProximaNova/Proxima_Nova_Thin.otf": [
		297,
		7,
		180
	],
	"./assets/fonts/holidayfree.otf": [
		298,
		7,
		181
	],
	"./assets/fonts/satisfy-regular.ttf": [
		299,
		7,
		182
	],
	"./assets/images/Cooking.png": [
		300,
		7,
		205
	],
	"./assets/images/DACE_PROMO_final.mp4": [
		214,
		7,
		183
	],
	"./assets/images/RightArrow.svg": [
		215,
		7,
		184
	],
	"./assets/images/Right_arraw.png": [
		205,
		7,
		206
	],
	"./assets/images/UpArrow.png": [
		255,
		7,
		207
	],
	"./assets/images/VB DACE  _final.mp4": [
		256,
		7,
		185
	],
	"./assets/images/Vector.png": [
		301,
		7,
		208
	],
	"./assets/images/active_star.png": [
		302,
		7,
		209
	],
	"./assets/images/arrow1.png": [
		303,
		7,
		210
	],
	"./assets/images/arrow_gold.png": [
		216,
		7,
		211
	],
	"./assets/images/arrow_grey.png": [
		257,
		7,
		212
	],
	"./assets/images/banner/vb-dace-independence-day.jpg": [
		304,
		7,
		213
	],
	"./assets/images/cart_icon.jpg": [
		305,
		7,
		214
	],
	"./assets/images/chevron-down.png": [
		306,
		7,
		215
	],
	"./assets/images/chevron-up.png": [
		307,
		7,
		216
	],
	"./assets/images/circle_check_full_green.png": [
		246,
		7,
		217
	],
	"./assets/images/coolicon.png": [
		213,
		7,
		218
	],
	"./assets/images/delete.png": [
		258,
		7,
		219
	],
	"./assets/images/disabled_star.png": [
		308,
		7,
		220
	],
	"./assets/images/dot.png": [
		309,
		7,
		221
	],
	"./assets/images/down_button.png": [
		269,
		7,
		222
	],
	"./assets/images/eye.png": [
		248,
		7,
		223
	],
	"./assets/images/fb_logo.png": [
		310,
		7,
		224
	],
	"./assets/images/filter.png": [
		270,
		7,
		225
	],
	"./assets/images/flag.png": [
		311,
		7,
		226
	],
	"./assets/images/heart_icon.jpg": [
		312,
		7,
		227
	],
	"./assets/images/heart_icon.png": [
		313,
		7,
		228
	],
	"./assets/images/home/Arrow 2.jpg": [
		314,
		7,
		229
	],
	"./assets/images/home/LARGER MID SECTION BANNER.png": [
		210,
		7,
		230
	],
	"./assets/images/home/RED SMALL BANNER.png": [
		217,
		7,
		231
	],
	"./assets/images/home/SILVER SMALL BANNER.png": [
		218,
		7,
		232
	],
	"./assets/images/home/coolicon.jpg": [
		315,
		7,
		233
	],
	"./assets/images/home/diwali.jpg": [
		316,
		7,
		234
	],
	"./assets/images/home/pressBlock/company1.png": [
		219,
		7,
		235
	],
	"./assets/images/home/pressBlock/company2.png": [
		220,
		7,
		236
	],
	"./assets/images/home/pressBlock/company3.png": [
		221,
		7,
		237
	],
	"./assets/images/home/pressBlock/company4.png": [
		222,
		7,
		238
	],
	"./assets/images/home/pressBlock/company5.png": [
		223,
		7,
		239
	],
	"./assets/images/home/pressBlock/company6.png": [
		224,
		7,
		240
	],
	"./assets/images/home/serviceImage_1.png": [
		225,
		7,
		241
	],
	"./assets/images/home/serviceImage_2.png": [
		226,
		7,
		242
	],
	"./assets/images/home/serviceImage_3.png": [
		227,
		7,
		243
	],
	"./assets/images/home/serviceImage_4.png": [
		228,
		7,
		244
	],
	"./assets/images/home/serviceImage_5.png": [
		229,
		7,
		245
	],
	"./assets/images/home/slide/image1.png": [
		317,
		7,
		246
	],
	"./assets/images/home/slide/image2.png": [
		318,
		7,
		247
	],
	"./assets/images/home/slide/image3.png": [
		319,
		7,
		248
	],
	"./assets/images/home/slide/image4.png": [
		320,
		7,
		249
	],
	"./assets/images/home/slide/image5.png": [
		321,
		7,
		250
	],
	"./assets/images/home/slide/image6.png": [
		322,
		7,
		251
	],
	"./assets/images/home/slide/image7.png": [
		323,
		7,
		252
	],
	"./assets/images/home/slide/image8.png": [
		324,
		7,
		253
	],
	"./assets/images/home/slide/image9.png": [
		325,
		7,
		254
	],
	"./assets/images/home/slide/slide1.png": [
		259,
		7,
		255
	],
	"./assets/images/home/slide/slide2.png": [
		326,
		7,
		256
	],
	"./assets/images/home/slide/slide3.png": [
		327,
		7,
		257
	],
	"./assets/images/home/slide/slide4.png": [
		328,
		7,
		258
	],
	"./assets/images/home/slide/slide5.png": [
		329,
		7,
		259
	],
	"./assets/images/home/welcome_image.png": [
		330,
		7,
		260
	],
	"./assets/images/home/welcome_image_mobile.jpg": [
		331,
		7,
		261
	],
	"./assets/images/icons-new/customer-support.png": [
		231,
		7,
		262
	],
	"./assets/images/icons-new/quality-guaranteed.png": [
		232,
		7,
		263
	],
	"./assets/images/icons-new/quick-shipping.png": [
		233,
		7,
		264
	],
	"./assets/images/icons-new/secured-payments.png": [
		234,
		7,
		265
	],
	"./assets/images/icons/google-play-badge.png": [
		230,
		7,
		266
	],
	"./assets/images/imageLft_login.png": [
		332,
		7,
		267
	],
	"./assets/images/instagram_logo.png": [
		333,
		7,
		268
	],
	"./assets/images/leftArrow.png": [
		204,
		7,
		269
	],
	"./assets/images/leftArrow_a.png": [
		334,
		7,
		270
	],
	"./assets/images/lindedin_logo.png": [
		335,
		7,
		271
	],
	"./assets/images/loading.gif": [
		336,
		7,
		272
	],
	"./assets/images/logo.jpg": [
		337,
		7,
		273
	],
	"./assets/images/logo.png": [
		207,
		7,
		274
	],
	"./assets/images/logo_1x.png": [
		338,
		7,
		275
	],
	"./assets/images/logo_2x.png": [
		339,
		7,
		276
	],
	"./assets/images/logo_3x.png": [
		247,
		7,
		277
	],
	"./assets/images/logo_4x.png": [
		340,
		7,
		278
	],
	"./assets/images/logo_with_title.png": [
		341,
		7,
		279
	],
	"./assets/images/logo_with_title_old.png": [
		342,
		7,
		280
	],
	"./assets/images/minus.png": [
		249,
		7,
		281
	],
	"./assets/images/newsfeed_logo.png": [
		343,
		7,
		282
	],
	"./assets/images/next-btn-old.png": [
		344,
		7,
		283
	],
	"./assets/images/next-btn.png": [
		211,
		7,
		284
	],
	"./assets/images/offer/ALLPROBackpack.png": [
		345,
		7,
		285
	],
	"./assets/images/offer/SignatureBlackFront.png": [
		346,
		7,
		286
	],
	"./assets/images/offer/SignatureBlackSide.png": [
		347,
		7,
		287
	],
	"./assets/images/pagNext.png": [
		251,
		7,
		288
	],
	"./assets/images/pagPrevious.png": [
		252,
		7,
		289
	],
	"./assets/images/plus.png": [
		250,
		7,
		290
	],
	"./assets/images/pressNxtBtn.svg": [
		235,
		7,
		186
	],
	"./assets/images/pressPrevBtn.svg": [
		236,
		7,
		187
	],
	"./assets/images/prev-btn-old.png": [
		348,
		7,
		291
	],
	"./assets/images/prev-btn.png": [
		212,
		7,
		292
	],
	"./assets/images/product/Product_1.png": [
		349,
		7,
		293
	],
	"./assets/images/product/Product_2.png": [
		350,
		7,
		294
	],
	"./assets/images/product/Product_3.png": [
		351,
		7,
		295
	],
	"./assets/images/product/Product_4.png": [
		352,
		7,
		296
	],
	"./assets/images/product/category_banner.png": [
		271,
		7,
		297
	],
	"./assets/images/product/videoImg1.png": [
		272,
		7,
		298
	],
	"./assets/images/product/videoImg2.png": [
		273,
		7,
		299
	],
	"./assets/images/product/videoImg3.png": [
		274,
		7,
		300
	],
	"./assets/images/rightArrow.png": [
		206,
		7,
		301
	],
	"./assets/images/right_arrow_white.png": [
		237,
		7,
		302
	],
	"./assets/images/search_icon.png": [
		238,
		7,
		303
	],
	"./assets/images/sign_in_icon.jpg": [
		353,
		7,
		304
	],
	"./assets/images/square_minus.png": [
		260,
		7,
		305
	],
	"./assets/images/square_plus.png": [
		261,
		7,
		306
	],
	"./assets/images/tope.mp4": [
		239,
		7,
		188
	],
	"./assets/images/x-circle.png": [
		354,
		7,
		307
	],
	"./assets/images/x-shape.png": [
		355,
		7,
		308
	],
	"./assets/images/youtube_logo.png": [
		356,
		7,
		309
	],
	"./assets/scss/abstracts/_abstracts.scss": [
		357,
		7,
		204
	],
	"./assets/scss/abstracts/font.scss": [
		358,
		7,
		139
	],
	"./assets/scss/abstracts/functions.scss": [
		359,
		7,
		140
	],
	"./assets/scss/abstracts/mixins.scss": [
		360,
		7,
		141
	],
	"./assets/scss/abstracts/variables.scss": [
		361,
		7,
		142
	],
	"./assets/scss/common.scss": [
		362,
		7,
		143
	],
	"./assets/scss/default/default.scss": [
		363,
		7,
		144
	],
	"./assets/scss/default/utility.scss": [
		364,
		7,
		145
	],
	"./assets/scss/icons/fonts/icomoon.eot": [
		365,
		7,
		189
	],
	"./assets/scss/icons/fonts/icomoon.svg": [
		366,
		7,
		190
	],
	"./assets/scss/icons/fonts/icomoon.ttf": [
		367,
		7,
		191
	],
	"./assets/scss/icons/fonts/icomoon.woff": [
		368,
		7,
		192
	],
	"./assets/scss/icons/selection": [
		160,
		3,
		131
	],
	"./assets/scss/icons/selection.json": [
		160,
		3,
		131
	],
	"./assets/scss/icons/style.css": [
		369,
		7,
		136
	],
	"./assets/scss/index.scss": [
		127,
		7
	],
	"./assets/scss/layouts/AuthLayout.scss": [
		123,
		7
	],
	"./assets/scss/layouts/CategoryLayout.scss": [
		370,
		7,
		146
	],
	"./assets/scss/layouts/HomeLayout.scss": [
		371,
		7,
		147
	],
	"./assets/scss/layouts/ProductLayout.scss": [
		372,
		7,
		148
	],
	"./assets/scss/layouts/cartLayout.scss": [
		373,
		7,
		149
	],
	"./assets/scss/vendors/vendors-dir.scss": [
		374,
		7,
		150
	],
	"./assets/svg/Facebook-Fill.svg": [
		240,
		7,
		193
	],
	"./assets/svg/Facebook.svg": [
		241,
		7,
		194
	],
	"./assets/svg/Insta-Fill.svg": [
		242,
		7,
		195
	],
	"./assets/svg/Insta.svg": [
		243,
		7,
		196
	],
	"./assets/svg/Youtube-Fill.svg": [
		244,
		7,
		197
	],
	"./assets/svg/Youtube.svg": [
		245,
		7,
		198
	],
	"./assets/svg/account_circle.svg": [
		375,
		7,
		199
	],
	"./assets/svg/cancel.svg": [
		376,
		7,
		200
	],
	"./assets/svg/leftArrow.svg": [
		208,
		7,
		201
	],
	"./assets/svg/logo.svg": [
		377,
		7,
		202
	],
	"./assets/svg/rightArrow.svg": [
		209,
		7,
		203
	],
	"./component/Currency/page": [
		139,
		9,
		113
	],
	"./component/Currency/page.jsx": [
		139,
		9,
		113
	],
	"./component/StaticPageComponent/StaticPageComponent": [
		158,
		9,
		0,
		1,
		2,
		3,
		84
	],
	"./component/StaticPageComponent/StaticPageComponent.js": [
		158,
		9,
		0,
		1,
		2,
		3,
		84
	],
	"./component/StoreComponent": [
		62,
		9,
		7,
		64
	],
	"./component/StoreComponent/": [
		62,
		9,
		7,
		64
	],
	"./component/StoreComponent/Addresscard/AddressCard": [
		151,
		9,
		7,
		102
	],
	"./component/StoreComponent/Addresscard/AddressCard.js": [
		151,
		9,
		7,
		102
	],
	"./component/StoreComponent/Addresscard/styles.scss": [
		265,
		7,
		151
	],
	"./component/StoreComponent/index": [
		62,
		9,
		7,
		64
	],
	"./component/StoreComponent/index.js": [
		62,
		9,
		7,
		64
	],
	"./component/auth": [
		54,
		9,
		0,
		1,
		2,
		3,
		35
	],
	"./component/auth/": [
		54,
		9,
		0,
		1,
		2,
		3,
		35
	],
	"./component/auth/Activate": [
		49,
		9,
		0,
		1,
		2,
		11,
		48
	],
	"./component/auth/Activate/": [
		49,
		9,
		0,
		1,
		2,
		11,
		48
	],
	"./component/auth/Activate/index": [
		49,
		9,
		0,
		1,
		2,
		11,
		48
	],
	"./component/auth/Activate/index.js": [
		49,
		9,
		0,
		1,
		2,
		11,
		48
	],
	"./component/auth/ForgotPwd": [
		50,
		9,
		0,
		1,
		2,
		3,
		44
	],
	"./component/auth/ForgotPwd/": [
		50,
		9,
		0,
		1,
		2,
		3,
		44
	],
	"./component/auth/ForgotPwd/index": [
		50,
		9,
		0,
		1,
		2,
		3,
		44
	],
	"./component/auth/ForgotPwd/index.js": [
		50,
		9,
		0,
		1,
		2,
		3,
		44
	],
	"./component/auth/ForgotPwd/validate": [
		161,
		9,
		114
	],
	"./component/auth/ForgotPwd/validate.js": [
		161,
		9,
		114
	],
	"./component/auth/Login": [
		51,
		9,
		0,
		1,
		2,
		3,
		41
	],
	"./component/auth/Login/": [
		51,
		9,
		0,
		1,
		2,
		3,
		41
	],
	"./component/auth/Login/index": [
		51,
		9,
		0,
		1,
		2,
		3,
		41
	],
	"./component/auth/Login/index.js": [
		51,
		9,
		0,
		1,
		2,
		3,
		41
	],
	"./component/auth/Login/validate": [
		162,
		9,
		115
	],
	"./component/auth/Login/validate.js": [
		162,
		9,
		115
	],
	"./component/auth/ResetPwd": [
		52,
		9,
		0,
		1,
		2,
		11,
		46
	],
	"./component/auth/ResetPwd/": [
		52,
		9,
		0,
		1,
		2,
		11,
		46
	],
	"./component/auth/ResetPwd/index": [
		52,
		9,
		0,
		1,
		2,
		11,
		46
	],
	"./component/auth/ResetPwd/index.js": [
		52,
		9,
		0,
		1,
		2,
		11,
		46
	],
	"./component/auth/Signup": [
		53,
		9,
		0,
		1,
		2,
		3,
		37
	],
	"./component/auth/Signup/": [
		53,
		9,
		0,
		1,
		2,
		3,
		37
	],
	"./component/auth/Signup/index": [
		53,
		9,
		0,
		1,
		2,
		3,
		37
	],
	"./component/auth/Signup/index.js": [
		53,
		9,
		0,
		1,
		2,
		3,
		37
	],
	"./component/auth/Signup/validate": [
		163,
		9,
		116
	],
	"./component/auth/Signup/validate.js": [
		163,
		9,
		116
	],
	"./component/auth/index": [
		54,
		9,
		0,
		1,
		2,
		3,
		35
	],
	"./component/auth/index.js": [
		54,
		9,
		0,
		1,
		2,
		3,
		35
	],
	"./component/blogDetail": [
		63,
		9,
		0,
		1,
		3,
		6,
		61
	],
	"./component/blogDetail/": [
		63,
		9,
		0,
		1,
		3,
		6,
		61
	],
	"./component/blogDetail/index": [
		63,
		9,
		0,
		1,
		3,
		6,
		61
	],
	"./component/blogDetail/index.js": [
		63,
		9,
		0,
		1,
		3,
		6,
		61
	],
	"./component/blogs": [
		64,
		9,
		0,
		1,
		6,
		45
	],
	"./component/blogs/": [
		64,
		9,
		0,
		1,
		6,
		45
	],
	"./component/blogs/blogCard": [
		152,
		9,
		6,
		101
	],
	"./component/blogs/blogCard.js": [
		152,
		9,
		6,
		101
	],
	"./component/blogs/index": [
		64,
		9,
		0,
		1,
		6,
		45
	],
	"./component/blogs/index.js": [
		64,
		9,
		0,
		1,
		6,
		45
	],
	"./component/cart": [
		65,
		9,
		0,
		1,
		43
	],
	"./component/cart/": [
		65,
		9,
		0,
		1,
		43
	],
	"./component/cart/index": [
		65,
		9,
		0,
		1,
		43
	],
	"./component/cart/index.js": [
		65,
		9,
		0,
		1,
		43
	],
	"./component/cart/offer_index": [
		164,
		9,
		0,
		1,
		97
	],
	"./component/cart/offer_index.js": [
		164,
		9,
		0,
		1,
		97
	],
	"./component/category": [
		66,
		9,
		0,
		1,
		2,
		5,
		36
	],
	"./component/category/": [
		66,
		9,
		0,
		1,
		2,
		5,
		36
	],
	"./component/category/index": [
		66,
		9,
		0,
		1,
		2,
		5,
		36
	],
	"./component/category/index.js": [
		66,
		9,
		0,
		1,
		2,
		5,
		36
	],
	"./component/category/old-index": [
		165,
		9,
		0,
		1,
		2,
		3,
		85
	],
	"./component/category/old-index.js": [
		165,
		9,
		0,
		1,
		2,
		3,
		85
	],
	"./component/category/tabs.category": [
		159,
		9,
		2,
		4,
		5,
		7,
		90
	],
	"./component/category/tabs.category.js": [
		159,
		9,
		2,
		4,
		5,
		7,
		90
	],
	"./component/common": [
		85,
		7,
		76
	],
	"./component/common/": [
		85,
		7,
		76
	],
	"./component/common/ChefNavTabs": [
		102,
		9,
		62
	],
	"./component/common/ChefNavTabs/": [
		102,
		9,
		62
	],
	"./component/common/ChefNavTabs/index": [
		102,
		9,
		62
	],
	"./component/common/ChefNavTabs/index.js": [
		102,
		9,
		62
	],
	"./component/common/ChefNavTabs/style.scss": [
		275,
		7,
		152
	],
	"./component/common/CommonPageLoader": [
		24,
		9
	],
	"./component/common/CommonPageLoader/": [
		24,
		9
	],
	"./component/common/CommonPageLoader/index": [
		24,
		9
	],
	"./component/common/CommonPageLoader/index.js": [
		24,
		9
	],
	"./component/common/CommonPageLoader/style.scss": [
		125,
		7
	],
	"./component/common/CommonTableLoader": [
		80,
		9,
		63
	],
	"./component/common/CommonTableLoader/": [
		80,
		9,
		63
	],
	"./component/common/CommonTableLoader/index": [
		80,
		9,
		63
	],
	"./component/common/CommonTableLoader/index.js": [
		80,
		9,
		63
	],
	"./component/common/CommonTableLoader/style.scss": [
		276,
		7,
		153
	],
	"./component/common/ErrorComponent": [
		60,
		9,
		73
	],
	"./component/common/ErrorComponent/": [
		60,
		9,
		73
	],
	"./component/common/ErrorComponent/index": [
		60,
		9,
		73
	],
	"./component/common/ErrorComponent/index.js": [
		60,
		9,
		73
	],
	"./component/common/FormErrorMessage": [
		47,
		9,
		74
	],
	"./component/common/FormErrorMessage/": [
		47,
		9,
		74
	],
	"./component/common/FormErrorMessage/index": [
		47,
		9,
		74
	],
	"./component/common/FormErrorMessage/index.js": [
		47,
		9,
		74
	],
	"./component/common/NormalButton": [
		81,
		9,
		75
	],
	"./component/common/NormalButton/": [
		81,
		9,
		75
	],
	"./component/common/NormalButton/index": [
		81,
		9,
		75
	],
	"./component/common/NormalButton/index.js": [
		81,
		9,
		75
	],
	"./component/common/NormalInput": [
		82,
		9,
		67
	],
	"./component/common/NormalInput/": [
		82,
		9,
		67
	],
	"./component/common/NormalInput/NormalInput.scss": [
		277,
		7,
		154
	],
	"./component/common/NormalInput/index": [
		82,
		9,
		67
	],
	"./component/common/NormalInput/index.js": [
		82,
		9,
		67
	],
	"./component/common/NormalSearch": [
		67,
		9,
		71
	],
	"./component/common/NormalSearch/": [
		67,
		9,
		71
	],
	"./component/common/NormalSearch/NormalSearch.scss": [
		266,
		7,
		155
	],
	"./component/common/NormalSearch/index": [
		67,
		9,
		71
	],
	"./component/common/NormalSearch/index.js": [
		67,
		9,
		71
	],
	"./component/common/NormalSelect": [
		83,
		9,
		10,
		68
	],
	"./component/common/NormalSelect/": [
		83,
		9,
		10,
		68
	],
	"./component/common/NormalSelect/index": [
		83,
		9,
		10,
		68
	],
	"./component/common/NormalSelect/index.js": [
		83,
		9,
		10,
		68
	],
	"./component/common/NormalSelect/select.scss": [
		278,
		7,
		156
	],
	"./component/common/Slider": [
		34,
		9,
		2,
		65
	],
	"./component/common/Slider/": [
		34,
		9,
		2,
		65
	],
	"./component/common/Slider/index": [
		34,
		9,
		2,
		65
	],
	"./component/common/Slider/index.js": [
		34,
		9,
		2,
		65
	],
	"./component/common/TableWrapper": [
		84,
		9,
		69
	],
	"./component/common/TableWrapper/": [
		84,
		9,
		69
	],
	"./component/common/TableWrapper/index": [
		84,
		9,
		69
	],
	"./component/common/TableWrapper/index.js": [
		84,
		9,
		69
	],
	"./component/common/TableWrapper/table.scss": [
		279,
		7,
		157
	],
	"./component/common/index": [
		85,
		7,
		76
	],
	"./component/common/index.js": [
		85,
		7,
		76
	],
	"./component/customerService": [
		78,
		9,
		5,
		40
	],
	"./component/customerService/": [
		78,
		9,
		5,
		40
	],
	"./component/customerService/index": [
		78,
		9,
		5,
		40
	],
	"./component/customerService/index.js": [
		78,
		9,
		5,
		40
	],
	"./component/home": [
		45,
		9,
		0,
		1,
		2,
		3,
		29
	],
	"./component/home/": [
		45,
		9,
		0,
		1,
		2,
		3,
		29
	],
	"./component/home/AdsofVBDACE": [
		68,
		9,
		4,
		50
	],
	"./component/home/AdsofVBDACE/": [
		68,
		9,
		4,
		50
	],
	"./component/home/AdsofVBDACE/index": [
		68,
		9,
		4,
		50
	],
	"./component/home/AdsofVBDACE/index.js": [
		68,
		9,
		4,
		50
	],
	"./component/home/AdsofVBDACE/style.module.css": [
		267,
		7,
		137
	],
	"./component/home/Banner": [
		36,
		9,
		78
	],
	"./component/home/Banner/": [
		36,
		9,
		78
	],
	"./component/home/Banner/index": [
		36,
		9,
		78
	],
	"./component/home/Banner/index.js": [
		36,
		9,
		78
	],
	"./component/home/BannerSwiper": [
		61,
		9,
		4,
		77
	],
	"./component/home/BannerSwiper/": [
		61,
		9,
		4,
		77
	],
	"./component/home/BannerSwiper/index": [
		61,
		9,
		4,
		77
	],
	"./component/home/BannerSwiper/index.js": [
		61,
		9,
		4,
		77
	],
	"./component/home/CollectionTabs": [
		69,
		9,
		0,
		1,
		4,
		5,
		34
	],
	"./component/home/CollectionTabs/": [
		69,
		9,
		0,
		1,
		4,
		5,
		34
	],
	"./component/home/CollectionTabs/index": [
		69,
		9,
		0,
		1,
		4,
		5,
		34
	],
	"./component/home/CollectionTabs/index.js": [
		69,
		9,
		0,
		1,
		4,
		5,
		34
	],
	"./component/home/DetailPage1": [
		37,
		9,
		79
	],
	"./component/home/DetailPage1/": [
		37,
		9,
		79
	],
	"./component/home/DetailPage1/index": [
		37,
		9,
		79
	],
	"./component/home/DetailPage1/index.js": [
		37,
		9,
		79
	],
	"./component/home/FooterBlock": [
		43,
		9,
		0,
		1,
		3,
		9,
		42
	],
	"./component/home/FooterBlock/": [
		43,
		9,
		0,
		1,
		3,
		9,
		42
	],
	"./component/home/FooterBlock/index": [
		43,
		9,
		0,
		1,
		3,
		9,
		42
	],
	"./component/home/FooterBlock/index.js": [
		43,
		9,
		0,
		1,
		3,
		9,
		42
	],
	"./component/home/ImgBlocks": [
		39,
		9,
		2,
		30,
		49
	],
	"./component/home/ImgBlocks/": [
		39,
		9,
		2,
		30,
		49
	],
	"./component/home/ImgBlocks/index": [
		39,
		9,
		2,
		30,
		49
	],
	"./component/home/ImgBlocks/index.js": [
		39,
		9,
		2,
		30,
		49
	],
	"./component/home/MultipleTabs": [
		40,
		9,
		0,
		1,
		4,
		5,
		32
	],
	"./component/home/MultipleTabs/": [
		40,
		9,
		0,
		1,
		4,
		5,
		32
	],
	"./component/home/MultipleTabs/index": [
		40,
		9,
		0,
		1,
		4,
		5,
		32
	],
	"./component/home/MultipleTabs/index.js": [
		40,
		9,
		0,
		1,
		4,
		5,
		32
	],
	"./component/home/PressBlock": [
		42,
		9,
		0,
		1,
		2,
		38
	],
	"./component/home/PressBlock/": [
		42,
		9,
		0,
		1,
		2,
		38
	],
	"./component/home/PressBlock/index": [
		42,
		9,
		0,
		1,
		2,
		38
	],
	"./component/home/PressBlock/index.js": [
		42,
		9,
		0,
		1,
		2,
		38
	],
	"./component/home/RecentBlogs": [
		70,
		9,
		0,
		1,
		6,
		9,
		47
	],
	"./component/home/RecentBlogs/": [
		70,
		9,
		0,
		1,
		6,
		9,
		47
	],
	"./component/home/RecentBlogs/index": [
		70,
		9,
		0,
		1,
		6,
		9,
		47
	],
	"./component/home/RecentBlogs/index.js": [
		70,
		9,
		0,
		1,
		6,
		9,
		47
	],
	"./component/home/ServiceBlock": [
		41,
		9,
		51
	],
	"./component/home/ServiceBlock/": [
		41,
		9,
		51
	],
	"./component/home/ServiceBlock/index": [
		41,
		9,
		51
	],
	"./component/home/ServiceBlock/index.js": [
		41,
		9,
		51
	],
	"./component/home/Slider": [
		38,
		9,
		0,
		1,
		2,
		4,
		39
	],
	"./component/home/Slider/": [
		38,
		9,
		0,
		1,
		2,
		4,
		39
	],
	"./component/home/Slider/index": [
		38,
		9,
		0,
		1,
		2,
		4,
		39
	],
	"./component/home/Slider/index.js": [
		38,
		9,
		0,
		1,
		2,
		4,
		39
	],
	"./component/home/TopNav": [
		44,
		9,
		0,
		1,
		5,
		9,
		31
	],
	"./component/home/TopNav/": [
		44,
		9,
		0,
		1,
		5,
		9,
		31
	],
	"./component/home/TopNav/index": [
		44,
		9,
		0,
		1,
		5,
		9,
		31
	],
	"./component/home/TopNav/index.js": [
		44,
		9,
		0,
		1,
		5,
		9,
		31
	],
	"./component/home/TopTabs": [
		35,
		9,
		0,
		1,
		10,
		55
	],
	"./component/home/TopTabs/": [
		35,
		9,
		0,
		1,
		10,
		55
	],
	"./component/home/TopTabs/index": [
		35,
		9,
		0,
		1,
		10,
		55
	],
	"./component/home/TopTabs/index.js": [
		35,
		9,
		0,
		1,
		10,
		55
	],
	"./component/home/VideoTestimonials": [
		79,
		9,
		4,
		52
	],
	"./component/home/VideoTestimonials/": [
		79,
		9,
		4,
		52
	],
	"./component/home/VideoTestimonials/index": [
		79,
		9,
		4,
		52
	],
	"./component/home/VideoTestimonials/index.js": [
		79,
		9,
		4,
		52
	],
	"./component/home/VideoTestimonials/style.module.css": [
		268,
		7,
		138
	],
	"./component/home/index": [
		45,
		9,
		0,
		1,
		2,
		3,
		29
	],
	"./component/home/index.js": [
		45,
		9,
		0,
		1,
		2,
		3,
		29
	],
	"./component/home/testimonials": [
		71,
		9,
		4,
		66
	],
	"./component/home/testimonials/": [
		71,
		9,
		4,
		66
	],
	"./component/home/testimonials/index": [
		71,
		9,
		4,
		66
	],
	"./component/home/testimonials/index.js": [
		71,
		9,
		4,
		66
	],
	"./component/myorder": [
		74,
		9,
		8,
		58
	],
	"./component/myorder/": [
		74,
		9,
		8,
		58
	],
	"./component/myorder/ReturnForm": [
		72,
		9,
		8,
		56
	],
	"./component/myorder/ReturnForm/": [
		72,
		9,
		8,
		56
	],
	"./component/myorder/ReturnForm/index": [
		72,
		9,
		8,
		56
	],
	"./component/myorder/ReturnForm/index.js": [
		72,
		9,
		8,
		56
	],
	"./component/myorder/ReturnTracking": [
		73,
		9,
		6,
		8,
		57
	],
	"./component/myorder/ReturnTracking/": [
		73,
		9,
		6,
		8,
		57
	],
	"./component/myorder/ReturnTracking/index": [
		73,
		9,
		6,
		8,
		57
	],
	"./component/myorder/ReturnTracking/index.js": [
		73,
		9,
		6,
		8,
		57
	],
	"./component/myorder/index": [
		74,
		9,
		8,
		58
	],
	"./component/myorder/index.js": [
		74,
		9,
		8,
		58
	],
	"./component/orders": [
		75,
		9,
		0,
		1,
		6,
		5,
		33
	],
	"./component/orders/": [
		75,
		9,
		0,
		1,
		6,
		5,
		33
	],
	"./component/orders/card": [
		155,
		9,
		6,
		96
	],
	"./component/orders/card.js": [
		155,
		9,
		6,
		96
	],
	"./component/orders/index": [
		75,
		9,
		0,
		1,
		6,
		5,
		33
	],
	"./component/orders/index.js": [
		75,
		9,
		0,
		1,
		6,
		5,
		33
	],
	"./component/product": [
		76,
		9,
		0,
		1,
		2,
		3,
		16
	],
	"./component/product/": [
		76,
		9,
		0,
		1,
		2,
		3,
		16
	],
	"./component/product/ProductSwiper": [
		56,
		9,
		4,
		7,
		54,
		59
	],
	"./component/product/ProductSwiper/": [
		56,
		9,
		4,
		7,
		54,
		59
	],
	"./component/product/ProductSwiper/index": [
		56,
		9,
		4,
		7,
		54,
		59
	],
	"./component/product/ProductSwiper/index.js": [
		56,
		9,
		4,
		7,
		54,
		59
	],
	"./component/product/ProductSwiper/styles.module.scss": [
		253,
		7,
		158
	],
	"./component/product/data/ManufacturingInfo": [
		148,
		9,
		117
	],
	"./component/product/data/ManufacturingInfo.js": [
		148,
		9,
		117
	],
	"./component/product/index": [
		76,
		9,
		0,
		1,
		2,
		3,
		16
	],
	"./component/product/index.js": [
		76,
		9,
		0,
		1,
		2,
		3,
		16
	],
	"./component/product/modal.product": [
		149,
		9,
		118
	],
	"./component/product/modal.product.js": [
		149,
		9,
		118
	],
	"./component/product/offer_index": [
		166,
		9,
		0,
		1,
		2,
		3,
		82
	],
	"./component/product/offer_index.js": [
		166,
		9,
		0,
		1,
		2,
		3,
		82
	],
	"./component/product/videoBlock.product": [
		167,
		9,
		2,
		7,
		99
	],
	"./component/product/videoBlock.product.js": [
		167,
		9,
		2,
		7,
		99
	],
	"./index": [
		27,
		9
	],
	"./index.js": [
		27,
		9
	],
	"./layout": [
		22,
		9
	],
	"./layout/": [
		22,
		9
	],
	"./layout/AuthLayout": [
		28,
		9
	],
	"./layout/AuthLayout.js": [
		28,
		9
	],
	"./layout/index": [
		22,
		9
	],
	"./layout/index.js": [
		22,
		9
	],
	"./pages": [
		99,
		9,
		80
	],
	"./pages/": [
		99,
		9,
		80
	],
	"./pages/Auth/activate": [
		168,
		9,
		0,
		1,
		2,
		3,
		91
	],
	"./pages/Auth/activate.js": [
		168,
		9,
		0,
		1,
		2,
		3,
		91
	],
	"./pages/Auth/forgotPwd": [
		169,
		9,
		0,
		1,
		2,
		3,
		92
	],
	"./pages/Auth/forgotPwd.js": [
		169,
		9,
		0,
		1,
		2,
		3,
		92
	],
	"./pages/Auth/login": [
		170,
		9,
		0,
		1,
		2,
		3,
		93
	],
	"./pages/Auth/login.js": [
		170,
		9,
		0,
		1,
		2,
		3,
		93
	],
	"./pages/Auth/resetPwd": [
		171,
		9,
		0,
		1,
		2,
		3,
		94
	],
	"./pages/Auth/resetPwd.js": [
		171,
		9,
		0,
		1,
		2,
		3,
		94
	],
	"./pages/Auth/signup": [
		172,
		9,
		0,
		1,
		2,
		3,
		95
	],
	"./pages/Auth/signup.js": [
		172,
		9,
		0,
		1,
		2,
		3,
		95
	],
	"./pages/BlogDetail": [
		86,
		9,
		0,
		1,
		2,
		3,
		21
	],
	"./pages/BlogDetail/": [
		86,
		9,
		0,
		1,
		2,
		3,
		21
	],
	"./pages/BlogDetail/index": [
		86,
		9,
		0,
		1,
		2,
		3,
		21
	],
	"./pages/BlogDetail/index.js": [
		86,
		9,
		0,
		1,
		2,
		3,
		21
	],
	"./pages/Blogs": [
		87,
		9,
		0,
		1,
		2,
		3,
		18
	],
	"./pages/Blogs/": [
		87,
		9,
		0,
		1,
		2,
		3,
		18
	],
	"./pages/Blogs/index": [
		87,
		9,
		0,
		1,
		2,
		3,
		18
	],
	"./pages/Blogs/index.js": [
		87,
		9,
		0,
		1,
		2,
		3,
		18
	],
	"./pages/Cart": [
		88,
		9,
		0,
		1,
		2,
		3,
		20
	],
	"./pages/Cart/": [
		88,
		9,
		0,
		1,
		2,
		3,
		20
	],
	"./pages/Cart/index": [
		88,
		9,
		0,
		1,
		2,
		3,
		20
	],
	"./pages/Cart/index.js": [
		88,
		9,
		0,
		1,
		2,
		3,
		20
	],
	"./pages/Category": [
		89,
		9,
		0,
		1,
		2,
		3,
		23
	],
	"./pages/Category/": [
		89,
		9,
		0,
		1,
		2,
		3,
		23
	],
	"./pages/Category/index": [
		89,
		9,
		0,
		1,
		2,
		3,
		23
	],
	"./pages/Category/index.js": [
		89,
		9,
		0,
		1,
		2,
		3,
		23
	],
	"./pages/ContactUs": [
		90,
		9,
		0,
		1,
		2,
		3,
		28
	],
	"./pages/ContactUs/": [
		90,
		9,
		0,
		1,
		2,
		3,
		28
	],
	"./pages/ContactUs/index": [
		90,
		9,
		0,
		1,
		2,
		3,
		28
	],
	"./pages/ContactUs/index.js": [
		90,
		9,
		0,
		1,
		2,
		3,
		28
	],
	"./pages/CustomerService": [
		91,
		9,
		0,
		1,
		2,
		3,
		22
	],
	"./pages/CustomerService/": [
		91,
		9,
		0,
		1,
		2,
		3,
		22
	],
	"./pages/CustomerService/index": [
		91,
		9,
		0,
		1,
		2,
		3,
		22
	],
	"./pages/CustomerService/index.js": [
		91,
		9,
		0,
		1,
		2,
		3,
		22
	],
	"./pages/Dummy/dummy": [
		173,
		9,
		0,
		1,
		2,
		3,
		86
	],
	"./pages/Dummy/dummy.js": [
		173,
		9,
		0,
		1,
		2,
		3,
		86
	],
	"./pages/Dummy/static": [
		174,
		9,
		0,
		1,
		2,
		3,
		83
	],
	"./pages/Dummy/static.js": [
		174,
		9,
		0,
		1,
		2,
		3,
		83
	],
	"./pages/Home": [
		92,
		9,
		0,
		1,
		2,
		3,
		17
	],
	"./pages/Home/": [
		92,
		9,
		0,
		1,
		2,
		3,
		17
	],
	"./pages/Home/index": [
		92,
		9,
		0,
		1,
		2,
		3,
		17
	],
	"./pages/Home/index.js": [
		92,
		9,
		0,
		1,
		2,
		3,
		17
	],
	"./pages/MyOrder": [
		95,
		9,
		0,
		1,
		2,
		3,
		14
	],
	"./pages/MyOrder/": [
		95,
		9,
		0,
		1,
		2,
		3,
		14
	],
	"./pages/MyOrder/Return": [
		93,
		9,
		0,
		1,
		2,
		3,
		13
	],
	"./pages/MyOrder/Return/": [
		93,
		9,
		0,
		1,
		2,
		3,
		13
	],
	"./pages/MyOrder/Return/index": [
		93,
		9,
		0,
		1,
		2,
		3,
		13
	],
	"./pages/MyOrder/Return/index.js": [
		93,
		9,
		0,
		1,
		2,
		3,
		13
	],
	"./pages/MyOrder/ReturnStatus": [
		94,
		9,
		0,
		1,
		2,
		3,
		12
	],
	"./pages/MyOrder/ReturnStatus/": [
		94,
		9,
		0,
		1,
		2,
		3,
		12
	],
	"./pages/MyOrder/ReturnStatus/index": [
		94,
		9,
		0,
		1,
		2,
		3,
		12
	],
	"./pages/MyOrder/ReturnStatus/index.js": [
		94,
		9,
		0,
		1,
		2,
		3,
		12
	],
	"./pages/MyOrder/index": [
		95,
		9,
		0,
		1,
		2,
		3,
		14
	],
	"./pages/MyOrder/index.js": [
		95,
		9,
		0,
		1,
		2,
		3,
		14
	],
	"./pages/Orders": [
		96,
		9,
		0,
		1,
		2,
		3,
		19
	],
	"./pages/Orders/": [
		96,
		9,
		0,
		1,
		2,
		3,
		19
	],
	"./pages/Orders/index": [
		96,
		9,
		0,
		1,
		2,
		3,
		19
	],
	"./pages/Orders/index.js": [
		96,
		9,
		0,
		1,
		2,
		3,
		19
	],
	"./pages/OurExperienceCenters": [
		97,
		9,
		0,
		1,
		2,
		3,
		24
	],
	"./pages/OurExperienceCenters/": [
		97,
		9,
		0,
		1,
		2,
		3,
		24
	],
	"./pages/OurExperienceCenters/index": [
		97,
		9,
		0,
		1,
		2,
		3,
		24
	],
	"./pages/OurExperienceCenters/index.js": [
		97,
		9,
		0,
		1,
		2,
		3,
		24
	],
	"./pages/OurExperienceCenters/style.module.scss": [
		280,
		7,
		159
	],
	"./pages/Product": [
		98,
		9,
		0,
		1,
		2,
		3,
		15
	],
	"./pages/Product/": [
		98,
		9,
		0,
		1,
		2,
		3,
		15
	],
	"./pages/Product/index": [
		98,
		9,
		0,
		1,
		2,
		3,
		15
	],
	"./pages/Product/index.js": [
		98,
		9,
		0,
		1,
		2,
		3,
		15
	],
	"./pages/about": [
		58,
		9,
		60
	],
	"./pages/about/": [
		58,
		9,
		60
	],
	"./pages/about/index": [
		58,
		9,
		60
	],
	"./pages/about/index.js": [
		58,
		9,
		60
	],
	"./pages/about/style.module.scss": [
		263,
		7,
		160
	],
	"./pages/index": [
		99,
		9,
		80
	],
	"./pages/index.js": [
		99,
		9,
		80
	],
	"./pages/kitchen-mate": [
		100,
		9,
		0,
		1,
		2,
		3,
		25
	],
	"./pages/kitchen-mate/": [
		100,
		9,
		0,
		1,
		2,
		3,
		25
	],
	"./pages/kitchen-mate/cocoChef": [
		175,
		9,
		0,
		1,
		2,
		3,
		87
	],
	"./pages/kitchen-mate/cocoChef.js": [
		175,
		9,
		0,
		1,
		2,
		3,
		87
	],
	"./pages/kitchen-mate/index": [
		100,
		9,
		0,
		1,
		2,
		3,
		25
	],
	"./pages/kitchen-mate/index.js": [
		100,
		9,
		0,
		1,
		2,
		3,
		25
	],
	"./pages/kitchen-mate/snackChef": [
		176,
		9,
		0,
		1,
		2,
		3,
		88
	],
	"./pages/kitchen-mate/snackChef.js": [
		176,
		9,
		0,
		1,
		2,
		3,
		88
	],
	"./pages/kitchen-mate/snackChefs": [
		177,
		9,
		0,
		1,
		2,
		3,
		89
	],
	"./pages/kitchen-mate/snackChefs.js": [
		177,
		9,
		0,
		1,
		2,
		3,
		89
	],
	"./pages/kitchen-mate/style.module.scss": [
		254,
		7,
		161
	],
	"./pages/shipping": [
		59,
		9,
		0,
		1,
		2,
		3,
		26
	],
	"./pages/shipping/": [
		59,
		9,
		0,
		1,
		2,
		3,
		26
	],
	"./pages/shipping/index": [
		59,
		9,
		0,
		1,
		2,
		3,
		26
	],
	"./pages/shipping/index.js": [
		59,
		9,
		0,
		1,
		2,
		3,
		26
	],
	"./pages/shipping/style.module.scss": [
		264,
		7,
		162
	],
	"./pages/terms-use": [
		57,
		9,
		0,
		1,
		2,
		3,
		27
	],
	"./pages/terms-use/": [
		57,
		9,
		0,
		1,
		2,
		3,
		27
	],
	"./pages/terms-use/index": [
		57,
		9,
		0,
		1,
		2,
		3,
		27
	],
	"./pages/terms-use/index.js": [
		57,
		9,
		0,
		1,
		2,
		3,
		27
	],
	"./pages/terms-use/style.module.scss": [
		262,
		7,
		163
	],
	"./redux/actions/actions": [
		14,
		9
	],
	"./redux/actions/actions.js": [
		14,
		9
	],
	"./redux/actions/productAction": [
		137,
		9,
		119
	],
	"./redux/actions/productAction.js": [
		137,
		9,
		119
	],
	"./redux/actions/userAction": [
		178,
		9,
		0,
		1,
		105
	],
	"./redux/actions/userAction.js": [
		178,
		9,
		0,
		1,
		105
	],
	"./redux/reducers": [
		23,
		9
	],
	"./redux/reducers/": [
		23,
		9
	],
	"./redux/reducers/index": [
		23,
		9
	],
	"./redux/reducers/index.js": [
		23,
		9
	],
	"./redux/reducers/taskReducer": [
		31,
		9
	],
	"./redux/reducers/taskReducer.js": [
		31,
		9
	],
	"./redux/store/store": [
		16,
		9
	],
	"./redux/store/store.js": [
		16,
		9
	],
	"./redux_old/actions/actionTypes": [
		144,
		9,
		120
	],
	"./redux_old/actions/actionTypes.js": [
		144,
		9,
		120
	],
	"./redux_old/actions/commonAction": [
		179,
		9,
		109
	],
	"./redux_old/actions/commonAction.js": [
		179,
		9,
		109
	],
	"./redux_old/actions/productAction": [
		180,
		9,
		110
	],
	"./redux_old/actions/productAction.js": [
		180,
		9,
		110
	],
	"./redux_old/reducer": [
		77,
		9,
		70
	],
	"./redux_old/reducer/": [
		77,
		9,
		70
	],
	"./redux_old/reducer/commonStore": [
		156,
		9,
		111
	],
	"./redux_old/reducer/commonStore.js": [
		156,
		9,
		111
	],
	"./redux_old/reducer/index": [
		77,
		9,
		70
	],
	"./redux_old/reducer/index.js": [
		77,
		9,
		70
	],
	"./redux_old/reducer/productStore": [
		157,
		9,
		112
	],
	"./redux_old/reducer/productStore.js": [
		157,
		9,
		112
	],
	"./redux_old/store": [
		101,
		9,
		53
	],
	"./redux_old/store/": [
		101,
		9,
		53
	],
	"./redux_old/store/index": [
		101,
		9,
		53
	],
	"./redux_old/store/index.js": [
		101,
		9,
		53
	],
	"./routes": [
		21,
		9
	],
	"./routes/": [
		21,
		9
	],
	"./routes/index": [
		21,
		9
	],
	"./routes/index.js": [
		21,
		9
	],
	"./routes/routes": [
		30,
		9
	],
	"./routes/routes.js": [
		30,
		9
	],
	"./service/apis": [
		55,
		9,
		72
	],
	"./service/apis/": [
		55,
		9,
		72
	],
	"./service/apis/blogs.apis": [
		141,
		9,
		0,
		1,
		106
	],
	"./service/apis/blogs.apis.js": [
		141,
		9,
		0,
		1,
		106
	],
	"./service/apis/customer.apis": [
		136,
		9,
		0,
		1,
		103
	],
	"./service/apis/customer.apis.js": [
		136,
		9,
		0,
		1,
		103
	],
	"./service/apis/index": [
		55,
		9,
		72
	],
	"./service/apis/index.js": [
		55,
		9,
		72
	],
	"./service/apis/products.apis": [
		135,
		9,
		0,
		1,
		107
	],
	"./service/apis/products.apis.js": [
		135,
		9,
		0,
		1,
		107
	],
	"./service/graphql": [
		33,
		9,
		0,
		81
	],
	"./service/graphql/": [
		33,
		9,
		0,
		81
	],
	"./service/graphql/apiQuery": [
		134,
		9,
		1,
		98
	],
	"./service/graphql/apiQuery.js": [
		134,
		9,
		1,
		98
	],
	"./service/graphql/index": [
		33,
		9,
		0,
		81
	],
	"./service/graphql/index.js": [
		33,
		9,
		0,
		81
	],
	"./serviceWorker": [
		32,
		9
	],
	"./serviceWorker.js": [
		32,
		9
	],
	"./utils/CodeSplitter": [
		17,
		9
	],
	"./utils/CodeSplitter.js": [
		17,
		9
	],
	"./utils/Constants": [
		181,
		9,
		121
	],
	"./utils/Constants.js": [
		181,
		9,
		121
	],
	"./utils/CouponDisplay": [
		182,
		9,
		100
	],
	"./utils/CouponDisplay.js": [
		182,
		9,
		100
	],
	"./utils/Currency": [
		140,
		9,
		122
	],
	"./utils/Currency.js": [
		140,
		9,
		122
	],
	"./utils/FormValidation": [
		143,
		9,
		123
	],
	"./utils/FormValidation.js": [
		143,
		9,
		123
	],
	"./utils/MetaData": [
		18,
		9
	],
	"./utils/MetaData.js": [
		18,
		9
	],
	"./utils/QuteSvg": [
		147,
		9,
		124
	],
	"./utils/QuteSvg.js": [
		147,
		9,
		124
	],
	"./utils/TestimonialsData": [
		146,
		9,
		125
	],
	"./utils/TestimonialsData.js": [
		146,
		9,
		125
	],
	"./utils/VideoTestimonialData": [
		153,
		9,
		126
	],
	"./utils/VideoTestimonialData.js": [
		153,
		9,
		126
	],
	"./utils/dateCustomFormat": [
		154,
		9,
		6,
		127
	],
	"./utils/dateCustomFormat.js": [
		154,
		9,
		6,
		127
	],
	"./utils/helperFunctions": [
		145,
		9,
		128
	],
	"./utils/helperFunctions.js": [
		145,
		9,
		128
	],
	"./utils/mock": [
		150,
		9,
		129
	],
	"./utils/mock.js": [
		150,
		9,
		129
	],
	"./utils/temp": [
		142,
		3,
		132
	],
	"./utils/temp.json": [
		142,
		3,
		132
	],
	"./utils/toast": [
		138,
		9,
		104
	],
	"./utils/toast.js": [
		138,
		9,
		104
	],
	"./utils/validation": [
		183,
		9,
		108,
		130
	],
	"./utils/validation.js": [
		183,
		9,
		108,
		130
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 190;
module.exports = webpackAsyncContext;